import { browser } from '$app/environment';
import { Page } from '$lib/utils/page';
import { pageConditions } from './__config/conditions';
import { policy, policyExceptionHandler } from './-policy';

export const prerender = true;

/**
 * Loads the page data
 * @returns {Promise<{page: Page} | undefined>} - The page data
 */
export async function load() {
	const metadata = {
		metaTag: [
			{
				content:
					'Welcome back! Log in to ABCmouse to discover new lessons, interactive activities, and personalized learning for kids ages 2–8.',
				name: 'description'
			},
			{
				content:
					'Welcome back! Log in to ABCmouse to discover new lessons, interactive activities, and personalized learning for kids ages 2–8.',
				property: 'og:description'
			},
			{
				content: 'ABCmouse Login | Welcome Back - Let’s Learn Something New',
				property: 'og:title'
			},
			{
				content: 'https://www.abcmouse.com/abc/login/',
				property: 'og:url'
			}
		],
		schemaOrg: {
			graph: {
				webPage: {
					description:
						'Welcome back! Log in to ABCmouse to discover new lessons, interactive activities, and personalized learning for kids ages 2–8.',
					id: 'https://www.abcmouse.com/abc/login/#webpage',
					name: 'ABCmouse Login | Welcome Back - Let’s Learn Something New',
					url: 'https://www.abcmouse.com/abc/login/'
				}
			}
		},
		title: 'ABCmouse Login | Welcome Back - Let’s Learn Something New'
	};
	if (browser) {
		const page = new Page({
			conditions: pageConditions,
			metadata,
			policies: { policy, policyExceptionHandler },
			routePath: '/login'
		});

		return {
			page
		};
	}

	return {
		metadata
	};
}
